import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Accordion, Card } from 'react-bootstrap';

import { IconConnection } from '../../../Atoms/Icon';
import { ContextToggle } from '../../WanSettings/Cell/ContextToggle';

import { getIsConnected } from './connection';
import styles from './wan.module.css';

const WanAccordion = ({
  connections,
  activeConnectionName,
  children,
  connectionTypeComponents,
  displayKpi,
}) => {
  return (
    <Accordion className="border-bottom">
      {connections.map(({ name, data }) => {
        const { connectionStatus, kpi } = data || {};
        const TabContentComponent = connectionTypeComponents[name];

        if (!TabContentComponent) return null;
        return (
          <Card key={name}>
            <Card.Header className="bg-white p-0">
              <ContextToggle
                eventKey={name}
                iconPosition="right"
                className="w-100 border border-bottom-0 p-2"
              >
                <div className="d-flex flex-auto justify-content-between">
                  <div className="d-flex">
                    <span
                      className="text-uppercase font-weight-bold"
                      style={{ fontSize: '15px' }}
                    >
                      {name.toLowerCase() === 'wifi' ? 'wi-fi' : name}
                    </span>
                  </div>
                  <div className="d-flex">
                    <span className="d-flex align-items-center">
                      <IconConnection
                        name={name}
                        isConnected={getIsConnected(connectionStatus)}
                        isActive={activeConnectionName === name}
                        className={displayKpi ? 'mr-2' : ''}
                        style={{
                          fontSize: getIsConnected(connectionStatus)
                            ? '22px'
                            : '16px',
                        }}
                      />
                    </span>
                    {displayKpi && (
                      <span className={classNames('text-gray', styles.kpiSm)}>
                        {kpi.toFixed(1)}
                      </span>
                    )}
                  </div>
                </div>
              </ContextToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={name} key={name}>
              <Card.Body className="py-2 config-details border-top">
                <TabContentComponent {...data}>{children}</TabContentComponent>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        );
      })}
    </Accordion>
  );
};

WanAccordion.propTypes = {
  connections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.shape({}).isRequired,
    }).isRequired,
  ).isRequired,
  activeConnectionName: PropTypes.oneOf([
    'vsat',
    'cell',
    'wifi',
    'alternate',
    'backup',
  ]),
  children: PropTypes.node,
  displayKpi: PropTypes.bool,
  connectionTypeComponents: PropTypes.shape({}),
};

export default WanAccordion;
